/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FinalStockErrorGoodsProcessCheckOrderIdFinalStockErrorGoodsProcessVo
 */
export interface FinalStockErrorGoodsProcessCheckOrderIdFinalStockErrorGoodsProcessVo {
    /**
     * 商品检查单ID
     * @type {number}
     * @memberof FinalStockErrorGoodsProcessCheckOrderIdFinalStockErrorGoodsProcessVo
     */
    checkOrderId?: number;
    /**
     * 数量
     * @type {number}
     * @memberof FinalStockErrorGoodsProcessCheckOrderIdFinalStockErrorGoodsProcessVo
     */
    quantity?: number;
}

/**
 * Check if a given object implements the FinalStockErrorGoodsProcessCheckOrderIdFinalStockErrorGoodsProcessVo interface.
 */
export function instanceOfFinalStockErrorGoodsProcessCheckOrderIdFinalStockErrorGoodsProcessVo(value: object): value is FinalStockErrorGoodsProcessCheckOrderIdFinalStockErrorGoodsProcessVo {
    return true;
}

export function FinalStockErrorGoodsProcessCheckOrderIdFinalStockErrorGoodsProcessVoFromJSON(json: any): FinalStockErrorGoodsProcessCheckOrderIdFinalStockErrorGoodsProcessVo {
    return FinalStockErrorGoodsProcessCheckOrderIdFinalStockErrorGoodsProcessVoFromJSONTyped(json, false);
}

export function FinalStockErrorGoodsProcessCheckOrderIdFinalStockErrorGoodsProcessVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinalStockErrorGoodsProcessCheckOrderIdFinalStockErrorGoodsProcessVo {
    if (json == null) {
        return json;
    }
    return {
        
        'checkOrderId': json['checkOrderId'] == null ? undefined : json['checkOrderId'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
    };
}

export function FinalStockErrorGoodsProcessCheckOrderIdFinalStockErrorGoodsProcessVoToJSON(json: any): FinalStockErrorGoodsProcessCheckOrderIdFinalStockErrorGoodsProcessVo {
    return FinalStockErrorGoodsProcessCheckOrderIdFinalStockErrorGoodsProcessVoToJSONTyped(json, false);
}

export function FinalStockErrorGoodsProcessCheckOrderIdFinalStockErrorGoodsProcessVoToJSONTyped(value?: FinalStockErrorGoodsProcessCheckOrderIdFinalStockErrorGoodsProcessVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'checkOrderId': value['checkOrderId'],
        'quantity': value['quantity'],
    };
}

